<h3 *ngIf="position">Edit: {{ position.title }}</h3>
<h3 *ngIf="!position">Create New Position</h3>
<form [formGroup]="positionForm">
  <div fxLayout="column">
    <div fxFlex>
      <div>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="80%">
          <mat-label>Position Title</mat-label>
          <input matInput type="text" formControlName="title" />
          <mat-error *ngIf="positionForm.get('title').hasError('notEmpty')">
            {{ positionForm.get('title').getError('notEmpty') }}
          </mat-error>
        </mat-form-field>
        <div fxFlex="5%"></div>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="15%">
          <mat-label>Seats</mat-label>
          <input matInput type="number" formControlName="seatCount" />
        </mat-form-field>
      </div>
    </div>
    <div fxFlex="100%">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%" class="mat-body-1">
        <mat-label>Position Description</mat-label>
        <textarea
          matInput
          matTextareaAutosize
          matAutosizeMinRows="2"
          matAutosizeMaxRows="10"
          type="text"
          formControlName="description"
        ></textarea>
        <mat-error *ngIf="positionForm.get('description').hasError('maxlength')">
          Description has a maximum of 500 characters
        </mat-error>
      </mat-form-field>
    </div>

    <mat-dialog-actions>
      <div *ngIf="!position">
        <button mat-raised-button color="primary" (click)="createPosition()" [disabled]="!positionForm.valid">
          CREATE
        </button>
      </div>
      <div *ngIf="position">
        <button mat-button color="primary" (click)="savePosition()" [disabled]="!positionForm.valid">UPDATE</button>
      </div>
      <div>
        <button type="button" mat-button (click)="dialogRef.close('no')">CANCEL</button>
      </div>
    </mat-dialog-actions>
  </div>
</form>
